import React from "react";

export default function LoadingPage() {
  return <div className="center">Loading...</div>;
}
